import React, { FC, useCallback } from 'react';
import styled from '@emotion/styled';
import { ISimpleProduct } from '$models';
import { key } from '~/utils';
import { useGtm } from '$hooks';
import { imageTint } from '$lib/style-helpers';
import { Link } from '$components/elements/link';
import { Carousel } from '$components/elements/carousel';
import { Image } from '$components/elements/image';

type Props = {
    products: ISimpleProduct[];
    selectedVariantNumber?: string;
};

export const VariantCarousel: FC<Props> = ({ products, selectedVariantNumber }) => {
    const { trackVirtualPageview } = useGtm();

    const renderVariant = (variant: ISimpleProduct) => (
        <Link href={variant.productUrl} replace scroll={false}>
            <ImageContainer isSelected={selectedVariantNumber === variant?.itemNumber}>
                <VariantImage height={100} src={variant.imageResources?.[0].url ?? ''} />
            </ImageContainer>
        </Link>
    );

    const trackVariantClick = useCallback(
        (product: ISimpleProduct) => {
            trackVirtualPageview(product?.productUrl);
        },
        [trackVirtualPageview]
    );

    return (
        <VariantCarouselContainer>
            <Carousel
                slidesPerView={4}
                spaceBetween={10}
                data={products}
                keyExtractor={key}
                template={renderVariant}
                navigation
                alwaysShowArrowButtons
                onCarouselItemClick={(product) => trackVariantClick(product)}
                breakpoints={{
                    // sm: {
                    //     slidesPerView: 5,
                    //     spaceBetween: 5,
                    // },
                    // md: {
                    //     slidesPerView: 5,
                    //     spaceBetween: 10,
                    // },
                    lg: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                }}
            />
        </VariantCarouselContainer>
    );
};

const VariantCarouselContainer = styled.div(({ theme }) => ({
    marginBottom: theme.space[3],
}));

const VariantImage = styled(Image)({
    position: 'relative',
    borderRadius: 0,
});

const ImageContainer = styled.div<{ isSelected: boolean }>(({ theme, isSelected }) => ({
    ...imageTint(theme),
    borderRadius: theme.general.borderRadius,
    padding: theme.space[2],
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    boxSizing: 'border-box',
    ':after': {
        border: isSelected ? `4px solid ${theme.colors.primaryTheme}` : `4px solid ${theme.colors.grey5}`,
        borderRadius: 0,
    },
}));
